/*-----------------------------------------------------------------
- Forms translations
-----------------------------------------------------------------*/
export default {

    select: {
        label: {
            group: {
                select  : '',
                deselect: '',
            },
            single: {
                select  : '',
                deselect: '',
            },
            selected: '',
        },
        placeholder: {
            default: 'از میان گزینه‌ها انتخاب کنید.',
            tag    : '',
            search : 'جستجو نمایید...',
        },
        message: {
            no_options: 'گزینه‌ای وجود ندارد.',
            no_search : 'برای مشاهده گزینه‌ها جستجو کنید',
            no_result : 'نتیجه‌ای یافت نشد.',
        },
    },

};
